import { render } from "./addSubAccount.vue?vue&type=template&id=2632a50e"
import script from "./addSubAccount.vue?vue&type=script&lang=js"
export * from "./addSubAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__